import Icon from "../../../components/base/Icon";




export default function PaymentRegisterThankYou() {

    return (
        <div>
            <div className="text-center">
                <Icon icon="check-circle" className="text-success" size={84} type="thin" />
            </div>
            <div className="text-center fs-4 mt-10">
                Thank you for the registration!
            </div>
        </div>
    )
}